export const generateEspanaDateObject = (): Date => {
  const date = new Date();
  const optionsTime: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'Europe/Madrid' // Zona horaria para España peninsular
  };
const optionsDate: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'Europe/Madrid' // Zona horaria para España peninsular
};

  const dateObject = new Date(
    date.toLocaleString('fr-CA', optionsDate) +
      'T' +
      date.toLocaleString('en-GB', optionsTime)
  );

  return dateObject;
};

export const isoFormatDate = (_dateObject?: Date) => {
  const dateObject = _dateObject ?? generateEspanaDateObject();

  const year = dateObject.getFullYear();
  const month =
    dateObject.getMonth() + 1 < 10
      ? `0${dateObject.getMonth() + 1}`
      : `${dateObject.getMonth() + 1}`;
  const day =
    dateObject.getDate() < 10
      ? `0${dateObject.getDate()}`
      : `${dateObject.getDate()}`;

  const hours =
    dateObject.getHours() < 10
      ? `0${dateObject.getHours()}`
      : `${dateObject.getHours()}`;
  const minutes =
    dateObject.getMinutes() < 10
      ? `0${dateObject.getMinutes()}`
      : `${dateObject.getMinutes()}`;
  const seconds =
    dateObject.getSeconds() < 10
      ? `0${dateObject.getSeconds()}`
      : `${dateObject.getSeconds()}`;

  const formatedDate = `${year}-${month}-${day}`;
  const formatedTime = `${hours}:${minutes}:${seconds}`;

  return {
    fullDate: `${formatedDate}T${formatedTime}`,
    date: formatedDate,
    time: formatedTime,
  };
};
